function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/**
 * @license Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * @module table/ui/inserttableview
 */
import { View } from 'ckeditor5/src/ui';
import './../../theme/inserttable.css';
/**
 * The table size view.
 *
 * It renders a 10x10 grid to choose the inserted table size.
 *
 * @extends module:ui/view~View
 * @implements module:ui/dropdown/dropdownpanelfocusable~DropdownPanelFocusable
 */

var InsertTableView = /*#__PURE__*/function (_View) {
  _inherits(InsertTableView, _View);

  var _super = _createSuper(InsertTableView);

  /**
   * @inheritDoc
   */
  function InsertTableView(locale) {
    var _this;

    _classCallCheck(this, InsertTableView);

    _this = _super.call(this, locale);
    var bind = _this.bindTemplate;
    /**
     * A collection of table size box items.
     *
     * @readonly
     * @member {module:ui/viewcollection~ViewCollection}
     */

    _this.items = _this._createGridCollection();
    /**
     * The currently selected number of rows of the new table.
     *
     * @observable
     * @member {Number} #rows
     */

    _this.set('rows', 0);
    /**
     * The currently selected number of columns of the new table.
     *
     * @observable
     * @member {Number} #columns
     */


    _this.set('columns', 0);
    /**
     * The label text displayed under the boxes.
     *
     * @observable
     * @member {String} #label
     */


    _this.bind('label').to(_assertThisInitialized(_this), 'columns', _assertThisInitialized(_this), 'rows', function (columns, rows) {
      return "".concat(rows, " \xD7 ").concat(columns);
    });

    _this.setTemplate({
      tag: 'div',
      attributes: {
        class: ['ck']
      },
      children: [{
        tag: 'div',
        attributes: {
          class: ['ck-insert-table-dropdown__grid']
        },
        on: {
          'mouseover@.ck-insert-table-dropdown-grid-box': bind.to('boxover')
        },
        children: _this.items
      }, {
        tag: 'div',
        attributes: {
          class: ['ck-insert-table-dropdown__label']
        },
        children: [{
          text: bind.to('label')
        }]
      }],
      on: {
        mousedown: bind.to(function (evt) {
          evt.preventDefault();
        }),
        click: bind.to(function () {
          _this.fire('execute');
        })
      }
    });

    _this.on('boxover', function (evt, domEvt) {
      var _domEvt$target$datase = domEvt.target.dataset,
          row = _domEvt$target$datase.row,
          column = _domEvt$target$datase.column; // As row & column indexes are zero-based transform it to number of selected rows & columns.

      _this.set({
        rows: parseInt(row),
        columns: parseInt(column)
      });
    });

    _this.on('change:columns', function () {
      _this._highlightGridBoxes();
    });

    _this.on('change:rows', function () {
      _this._highlightGridBoxes();
    });

    return _this;
  }
  /**
   * @inheritDoc
   */


  _createClass(InsertTableView, [{
    key: "focus",
    value: function focus() {// The dropdown panel expects DropdownPanelFocusable interface on views passed to dropdown panel. See #30.
      // The method should be implemented while working on keyboard support for this view. See #22.
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "focusLast",
    value: function focusLast() {// The dropdown panel expects DropdownPanelFocusable interface on views passed to dropdown panel. See #30.
      // The method should be implemented while working on keyboard support for this view. See #22.
    }
    /**
     * Highlights grid boxes depending on rows and columns selected.
     *
     * @private
     */

  }, {
    key: "_highlightGridBoxes",
    value: function _highlightGridBoxes() {
      var rows = this.rows;
      var columns = this.columns;
      this.items.map(function (boxView, index) {
        // Translate box index to the row & column index.
        var itemRow = Math.floor(index / 10);
        var itemColumn = index % 10; // Grid box is highlighted when its row & column index belongs to selected number of rows & columns.

        var isOn = itemRow < rows && itemColumn < columns;
        boxView.set('isOn', isOn);
      });
    }
    /**
     * @private
     * @returns {module:ui/viewcollection~ViewCollection} A view collection containing boxes to be placed in a table grid.
     */

  }, {
    key: "_createGridCollection",
    value: function _createGridCollection() {
      var boxes = []; // Add grid boxes to table selection view.

      for (var index = 0; index < 100; index++) {
        var row = Math.floor(index / 10);
        var column = index % 10;
        boxes.push(new TableSizeGridBoxView(this.locale, row + 1, column + 1));
      }

      return this.createCollection(boxes);
    }
    /**
     * Fired when the mouse hover over one of the {@link #items child grid boxes}.
     *
     * @event boxover
     */

  }]);

  return InsertTableView;
}(View);
/**
 * A single grid box view element.
 *
 * This class is used to render the table size selection grid in {@link module:table/ui/inserttableview~InsertTableView}.
 *
 * @private
 */


export { InsertTableView as default };

var TableSizeGridBoxView = /*#__PURE__*/function (_View2) {
  _inherits(TableSizeGridBoxView, _View2);

  var _super2 = _createSuper(TableSizeGridBoxView);

  /**
   * @inheritDoc
   */
  function TableSizeGridBoxView(locale, row, column) {
    var _this2;

    _classCallCheck(this, TableSizeGridBoxView);

    _this2 = _super2.call(this, locale);
    var bind = _this2.bindTemplate;
    /**
     * Controls whether the grid box view is "on".
     *
     * @observable
     * @member {Boolean} #isOn
     */

    _this2.set('isOn', false);

    _this2.setTemplate({
      tag: 'div',
      attributes: {
        class: ['ck-insert-table-dropdown-grid-box', bind.if('isOn', 'ck-on')],
        'data-row': row,
        'data-column': column
      }
    });

    return _this2;
  }

  return TableSizeGridBoxView;
}(View);